
const PORTER_GUIDE_ID = process.env.REACT_APP_PORTER_GUIDE_ID;

export const sortGuidesByRatings = guide => {
   return guide.averageRating;
}

export const sortGuidesByDailyWage = guide => {
  const { amount } = guide.dailyWages || { amount: 0 };
  return amount;
};

export const filterOutDailyWage = guide => {
  return guide.dailyWages !== null;
};

export const filterOutPorterGuides = guide => {
  return guide.id !== PORTER_GUIDE_ID;
};
